























































































import { Vue, Component } from "vue-property-decorator";
import { photoList, imgList, img2List } from "./data";
@Component
export default class Magazine extends Vue {
  public formData = {};
  public photoList = photoList;
  public imgList = imgList;
  public img2List = img2List;
}
